import { Modal } from "react-bootstrap";
import { StyledModalTitle } from "../../../@ui/StyledModalTitle";
import { RoyaltyOrderItem } from "../../../types/Royalties/RoyaltyOrderItem";
import { OSMRNRoyaltyData } from "../../../types/Royalties/OSMRNRoyaltyData";
import { RoyaltyReceiver } from "../../../constant/RoyaltyReceiver";
import OSMRNRoyaltyDetails from "./OSMRNRoyaltyDetails";
import { OSHighwaysRoyaltyData } from "../../../types/Royalties/OSHighwaysRoyaltyData";
import OSHighwaysRoyaltyDetails from "./OSHighwaysRoyaltyDetails";
import ThemedModal from "../../../@ui/Modal/ThemedModal";

interface RoyaltyModalProps {
  selectedRoyalty: RoyaltyOrderItem;
  onClose: () => void;
}

const RoyaltyModal = ({ selectedRoyalty, onClose }: RoyaltyModalProps) => {
  const mrnLayerName = "OS Multi-Modal Routing Network";
  const highwaysLayerName = "OS Highways";
  function isOSMRNRoyaltyData(
    royaltyData: any,
    layerName: string,
  ): royaltyData is OSMRNRoyaltyData {
    return royaltyData.users !== undefined && layerName === mrnLayerName;
  }

  function isOSHighwaysRoyaltyData(
    royaltyData: any,
    layerName: string,
  ): royaltyData is OSHighwaysRoyaltyData {
    return royaltyData.users !== undefined && layerName === highwaysLayerName;
  }

  return (
    <>
      <ThemedModal
        onHide={() => onClose()}
        centered
        show={selectedRoyalty != null}
        scrollable={true}
      >
        <Modal.Header className="bg-secondary text-white" closeButton>
          <StyledModalTitle>Royalty Details</StyledModalTitle>
        </Modal.Header>
        <Modal.Body className="bg-light text-black overflow-auto">
          <dl>
            <dt>Customer Name</dt>
            <dd>{selectedRoyalty.organisationName}</dd>
            <dt>Order Date</dt>
            <dd>{selectedRoyalty.orderDate.toFormat("dd/MM/yyyy")}</dd>
            <dt>Layer</dt>
            <dd>{selectedRoyalty.layerName}</dd>
            <dt>Order Item Value (ex VAT)</dt>
            <dd>£{selectedRoyalty.orderItemValue}</dd>
            <dt>Royalty Value</dt>
            <dd>£{selectedRoyalty.royaltyData.royaltyValue.toFixed(2)}</dd>
            <dt>Recipient</dt>
            <dd>
              {RoyaltyReceiver[selectedRoyalty.royaltyData.royaltyReceiver]}
            </dd>
            {isOSMRNRoyaltyData(
              selectedRoyalty.royaltyData,
              selectedRoyalty.layerName,
            ) && (
              <OSMRNRoyaltyDetails royaltyData={selectedRoyalty.royaltyData} />
            )}
            {isOSHighwaysRoyaltyData(
              selectedRoyalty.royaltyData,
              selectedRoyalty.layerName,
            ) && (
              <OSHighwaysRoyaltyDetails
                royaltyData={selectedRoyalty.royaltyData}
              />
            )}
          </dl>
        </Modal.Body>
      </ThemedModal>
    </>
  );
};

export default RoyaltyModal;
